import React from 'react';
import ArrowDownWhite from 'src/assets/images/icons/arrow-link-down-expand-small_white.svg';
import { t } from 'i18next';

export const ExpandMore = () => {
  return <img src={ArrowDownWhite} alt={t('ArrowDownAltText')} />;
};
